<div class="custom-pdp container my-4 pt-4">
  <div class="row" *ngIf="displaySection">
    <div class="col-md-8 pb-2 u-border-right-grey pr-md-4">
      <img
        *ngIf="!productInfo?.images || !productInfo?.images?.PRIMARY"
        class="img-fluid mb-2 d-sm-none"
        src="{{ fallbackImage }}"
        [alt]="productInfo?.summary" />
      <cx-media
        class="img-fluid mb-2 d-sm-none"
        [container]="productInfo?.images?.PRIMARY"
        format="product"
        [alt]="productInfo?.summary"></cx-media>
      <h1 class="c-heading c-heading-h2 mb-3">{{ productInfo?.name }}</h1>
      <p class="text-fixed-medium" [innerHTML]="description"></p>
      <br />
      <div class="text-fixed-medium">
        <p *ngIf="productInfo?.batchInfo?.batchNumber">
          <strong>{{ 'plp.batchNumber' | cxTranslate }} </strong>
          <span>{{ productInfo?.batchInfo?.batchNumber }}</span>
        </p>
        <p *ngIf="productInfo?.batchInfo?.batchNumber">
          <strong>{{ 'plp.expiryDate' | cxTranslate }} </strong>
          <span>{{ productInfo?.batchInfo?.expiryDate }}</span>
        </p>
        <p *ngIf="productInfo?.batchInfo?.batchNumber">
          <strong>{{ 'plp.batchInfo' | cxTranslate }}</strong>
        </p>
        <p>
          <strong>{{ 'plp.productNumber' | cxTranslate }}: </strong>
          <span>{{ productInfo?.sapEan }}</span>
        </p>
        <p *ngIf="productInfo?.actualPotency">
          <strong>{{ 'plp.actualPotency' | cxTranslate }} </strong>
          <span>{{ productInfo?.actualPotency }}</span>
        </p>
        <div *ngIf="productInfo?.actualPotency">
          <span *ngIf="productInfo?.iuPrice == undefined ||productInfo?.iuPrice?.value === undefined">
            <strong>{{ 'plp.iuPrice' | cxTranslate }} </strong>
            -
          </span>
          <span *ngIf="productInfo?.iuPrice && productInfo?.iuPrice?.value !== undefined">
            <strong>{{ 'plp.iuPrice' | cxTranslate }} </strong>
            {{ productInfo?.iuPrice?.value | localCurrency }}
          </span>
        </div>

        <div *ngIf="productInfo?.showStockAvailability">
          <div class="c-stock-level c-popover-black-container mb-2 mt-4 d-flex">
            Stock availability:&nbsp;&nbsp;
            <div
              class="c-round-chip"
              [ngClass]="{
                'c-round-chip-limited': productInfo?.stockAvailableStatus === StockAvailableStatus.LIMITED,
                'c-round-chip-low': productInfo?.stockAvailableStatus === StockAvailableStatus.LOW,
                'c-round-chip-normal':productInfo?.stockAvailableStatus === StockAvailableStatus.NORMAL
              }"
              (mouseenter)="p1.open()"
              [ngbPopover]="popOverBatch"
              #p1="ngbPopover"
              placement="top"
              (mouseleave)="p1.close()"></div>
            <ng-template #popOverBatch>
              <div class="c-popover-black">
                <p *ngIf="productInfo?.stockAvailableStatus == 'LOW'">
                  Low stock<br /><span>Stock is Limited</span>
                </p>
                <p *ngIf="productInfo?.stockAvailableStatus == 'NORMAL'">
                  Normal stock<br /><span>Stock is available</span>
                </p>
                <p *ngIf="productInfo?.stockAvailableStatus === StockAvailableStatus.LIMITED && !productInfo?.allowLimitedStockProducts">
                  Stock Unavailable<br /><span>
                  Please call Customer Support</span>
                </p>
                <p *ngIf="productInfo?.stockAvailableStatus === StockAvailableStatus.LIMITED && productInfo?.allowLimitedStockProducts">
                  Stock is very Limited <br />
                </p>
              </div>
            </ng-template>
          </div>
        </div>
        <hr class="line" />

        <app-contracts-partial
          [contractFromCartApi]="contractFromCartApi"
          [conditions]="productInfo?.conditions"
          [selectedChannel]="selectedChannel"
          [hasMatchingContract]="hasMatchingContract"
          [showPriceGroup]="showPriceGroup"
          [priceGroupToShow]="priceGroupToShow"
          (selectedContract)="onSelectedContract($event)"
          (selectPriceGroup)="onSelectPriceGroup($event)"
          [rowView]="true"
        />

        <div *ngIf="userDetails !== undefined">
          <div *ngIf="!productInfo?.flu">
            <div class="d-flex justify-content-around justify-content-md-between flex-wrap mt-2">
              <div class="mb-2">
                <h5 *ngIf="productInfo?.actualPotency; else notActualPotency" class="mb-2 text-center font-weight-bold color-grey-dark">
                  {{ 'plp.unitPrice' | cxTranslate }}
                </h5>
                <ng-template #notActualPotency>
                  <h5 class="mb-2 text-center font-weight-bold color-grey-dark">
                    {{ 'plp.yourPrice' | cxTranslate }}
                    {{ ProductUtils.getUnitTranslation(selectedChannel) }}
                  </h5>
                </ng-template>
                <!-- Private Price -->
                <p class="c-heading c-heading-h3" *ngIf="selectedChannel === PriceChannel.PRIVATE ||productInfo?.conditions == undefined">
                  <span *ngIf="productInfo?.price == undefined || productInfo?.price?.value === undefined">-</span>
                  <span *ngIf="productInfo?.price && productInfo?.price?.value !== undefined">
                    {{ productInfo?.price?.value | localCurrency }}
                  </span>
                </p>
                <!-- Dynamic Price Public Channel -->
                <p
                  class="c-heading c-heading-h3"
                  *ngIf="selectedChannel === PriceChannel.PUBLIC">
                  <span *ngIf="productInfo?.conditions?.length >= 1">
                    <ng-container
                      *ngFor="let condition of productInfo?.conditions">
                      <ng-container
                        *ngIf="
                          condition?.contractId == contractSelectedId &&
                          priceToShow
                        ">
                        {{ priceToShow | localCurrency }}
                      </ng-container>
                    </ng-container>
                  </span>
                </p>
              </div>
              <!-- Quantity -->
              <div class="mb-2 units-area">
                <div *ngIf="!productInfo?.discontinued && productInfo?.available">
                  <label for="{{ 'prodQuantity' + productInfo?.code }}" class="mb-2 text-center font-weight-bold color-grey-dark">
                    {{ 'plp.units' | cxTranslate }}
                    {{ ProductUtils.getUnitTranslation(selectedChannel) }}
                  </label>

                  <div class="unit-area d-flex flex-nowrap align-items-center justify-content-center">
                    <span id="{{ 'unitMinus' + productInfo?.code }}" class="d-none"></span>
                    <span id="{{ 'unitMinusDisable' + productInfo?.code }}" class="d-none"></span>
                    <span id="{{ 'unitPlus' + productInfo?.code }}" class="d-none"></span>
                    <span id="{{ 'unitPlusDisable' + productInfo?.code }}" class="d-none"></span>
                    <button
                      id="{{ 'minusIcon' + productInfo?.code }}"
                      class="c-count-change-btn disabled"
                      aria-hidden="true"
                      (click)="performQuantityComputation(2)">
                      <em class="fa fa-minus" aria-hidden="true"></em>
                    </button>
                    <input
                      [class]="{
                        'custom-pdp__quantityPublic': selectedChannel === PriceChannel.PUBLIC,
                        'custom-pdp__quantityPrivate': selectedChannel === PriceChannel.PRIVATE
                      }"
                      autoSizeInput
                      [includeBorders]="true"
                      type="number"
                      class="prod-quantity text-center"
                      value="{{ productInfo?.numberOfUnitsPerCarton && conditionsForCartonsLogicMeet? productInfo.numberOfUnitsPerCarton : '1' }}"
                      (blur)="performQuantityComputation(null)"
                      id="{{ 'prodQuantity' + productInfo?.code }}"
                      min="1"
                      max="{{ProductUtils.getMaximumQuantity(selectedChannel)}}"
                    />
                    <button
                      id="{{ 'plusIcon' + productInfo?.code }}"
                      class="c-count-change-btn"
                      aria-hidden="true"
                      (click)="performQuantityComputation(1)">
                      <em class="fa fa-plus" aria-hidden="true"></em>
                    </button>
                  </div>
                  <div *ngIf="conditionsForCartonsLogicMeet" class="w-100 mt-1 d-flex justify-content-center text-center" id="{{'noOfCartons'+productInfo?.code}}">
                    <span class="red">min 1 cx embarque</span>
                  </div>
                </div>
              </div>
              <app-add-to-cart-button
                class="col-xs-12 col-sm-4 col-md-4 col-lg-4 p-0 my-4 my-sm-2 d-flex align-items-end button-area"
              [productInfo]="productInfo"
              [selectedChannel]="selectedChannel"
              [userDetails]="userDetails"
              [contractSelected]="contractSelected"
              [priceToShowGroupId]="priceToShowGroupId"
              [contractSelectedId]="contractSelectedId"
              [carts]="carts"
              [enableBtn]="enableBtn"
              [fullWidthButton]="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <aside aria-label="Product Details" class="col-md-4 pl-md-4">
      <div class="d-none d-sm-block mb-4">
        <a *ngIf="productInfo?.images; else noImage" (click)="openImage(content)" class="d-none d-sm-block">
          <img *ngIf="!productInfo?.images || !productInfo?.images?.PRIMARY"
            class="img-fluid mb-2 d-sm-none"
            src="{{ fallbackImage }}"
            [alt]="productInfo?.summary" />
          <cx-media
            *ngIf="productInfo?.images && productInfo?.images?.PRIMARY"
            class="img-fluid"
            [container]="productInfo?.images?.PRIMARY"
            format="product"
            [alt]="productInfo?.summary" />
        </a>
        <ng-template #noImage>
          <a><img class="img-fluid" [src]="fallbackImage" alt="" /></a>
        </ng-template>
        <ng-template #content let-modal>
          <ngb-carousel
            [showNavigationIndicators]="false"
            [showNavigationArrows]="false"
            *ngIf="productInfo?.images || productInfo?.images?.length > 0">
            <ng-template ngbSlide>
              <div class="picsum-img-wrapper">
                <img *ngIf="!productInfo?.images || !productInfo?.images?.PRIMARY"
                  class="img-fluid mb-2 d-sm-none"
                  src="{{ fallbackImage }}"
                  [alt]="productInfo?.summary" />
                <cx-media
                  *ngIf="productInfo?.images && productInfo?.images?.PRIMARY"
                  class="cx-product-image carousel-pdp"
                  [container]="productInfo?.images?.PRIMARY"
                  format="product"
                  [alt]="productInfo?.name"/>
                <div class="xzoom-thumbs">
                  <a class="item">
                    <img *ngIf="!productInfo?.images || !productInfo?.images?.PRIMARY"
                      class="img-fluid mb-2 d-sm-none"
                      src="{{ fallbackImage }}"
                      [alt]="productInfo?.summary" />
                    <cx-media
                      *ngIf="productInfo?.images && productInfo?.images?.PRIMARY"
                      class="cx-product-image carousel-zoom"
                      [container]="productInfo?.images?.PRIMARY"
                      format="product"
                      [alt]="productInfo?.name" />
                  </a>
                </div>
              </div>
            </ng-template>
          </ngb-carousel>
        </ng-template>
      </div>
      <div *ngIf="monographLink" aria-label="Product Details Pdf" class="col-sm-3 right-navigation float-left resources-section">
        <div>
          <div class="prod-detail-pdfs">
            <h3 class="c-heading c-heading-h4 color-secondary">{{ 'plp.resources' | cxTranslate }}</h3>
            <a [href]="monographLink" target="_blank" alt="" class="c-link">
              <em class="fa fa-file-pdf-o" aria-hidden="true"></em>
              {{ 'plp.monograph' | cxTranslate }}
            </a>
          </div>
        </div>
      </div>
    </aside>
  </div>
  <div class="row">
    <div class="col-xs-12 col-sm-8 col-md-8 last-section" *ngIf="userDetails !== undefined">
      <div class="yCmsContentSlot productDetailsPageSectionCrossSelling">
        <div class="yCmsComponent productDetailsPageSectionCrossSelling-component">
          <div class="row mt-4">
            <div class="col-md-12" *ngIf="relatedProducts?.length > 0">
              <h2 class="c-heading c-heading-h2">{{ 'plp.relatedProducts' | cxTranslate }}</h2>
              <ngx-slick-carousel
                class="carousel"
                #slickModal="slick-carousel"
                [config]="slideConfig"
                (init)="slickInit($event)"
                (breakpoint)="breakpoint($event)"
                (afterChange)="afterChange($event)"
                (beforeChange)="beforeChange($event)">
                <app-custom-product-card ngxSlickItem *ngFor="let product of relatedProducts" [iconDisplay]="false" />
              </ngx-slick-carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
